import React from 'react';
import { Button } from 'reactstrap';
import { ArrowLeft } from 'lucide-react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

interface BackButtonProps {
    label?: string;
    className?: string;
}

function BackButton({ label = 'Back', className = '' }: BackButtonProps) {
    const navigate: NavigateFunction = useNavigate();

    return (
        <div className={`d-flex align-items-center mb-3 ${className}`}>
            <Button
                color="link"
                className="text-decoration-none p-0 d-flex align-items-center gap-1"
                onClick={() => navigate(-1)}
            >
                <ArrowLeft size={18} />
                <span>{label}</span>
            </Button>
        </div>
    );
}

export default BackButton;